import { getFormattedTime } from '@wix/live-video-commons';
import React, { useState, useEffect } from 'react';
const format = (lang, value, unit, date) => {
    try {
        const intl = new Intl.RelativeTimeFormat(lang || 'en', { style: 'narrow' });
        return intl.format(value, unit);
    }
    catch (e) {
        return getFormattedTime({ locale: lang, timestamp: date });
    }
};
export const MessageTime = ({ date, justNowText, lang }) => {
    const [text, setText] = useState();
    const updateText = () => {
        const ms = Number(Date.now()) - Number(date);
        const s = Math.floor(ms / 1000);
        const m = Math.floor(s / 60);
        const h = Math.floor(m / 60);
        const d = Math.floor(h / 24);
        const w = Math.floor(d / 7);
        if (w) {
            setText(format(lang, -w, 'week', date));
        }
        else if (d) {
            setText(format(lang, -d, 'day', date));
        }
        else if (h) {
            setText(format(lang, -h, 'hour', date));
        }
        else if (m) {
            setText(format(lang, -m, 'minute', date));
        }
        else {
            setText(justNowText);
        }
    };
    useEffect(() => {
        updateText();
        const interval = setInterval(updateText, 60000);
        return () => {
            clearInterval(interval);
        };
    }, []);
    return React.createElement(React.Fragment, null, text);
};
//# sourceMappingURL=message-time.js.map